<div>
  <div class="titleWrapper">
    <span class="title">{{title}}</span>
    <span class="count">{{count}}</span>
  </div>
  <ng-container *ngIf="config">
    <div *ngFor="let header of config" class="headerCell">
      {{header.title}}
    </div>
  </ng-container>
  <ng-container *ngIf="list">
    <div *ngFor="let row of list" class="row">
      <div>{{row.os}}</div>
      <div>{{row.time}}</div>
      <div>{{row.status}}</div>
    </div>
  </ng-container>
</div> 